<template>
  <div class="w-full justify-self-end grid sticky z-40 transition-all duration-200 m_650:w-fit" id="js_select_sticky">
    <div class="w-full pt-s10 pb-0 m_650:pb-s25 m_650:pt-s20 m_650:w-fit m_1000:pb-s20 justify-self-end">
      <div class="bg-black py-s10 px-s20 flex justify-between" id="js_brand_btn">
        <button type="button" class="hidden m_1000:flex items-center mr-s40 group" @click="showBrands = !showBrands; showSort = false;">
          <p class="text-white text-t18 mr-s5 m_1000:group-hover:text-gold m_1000:transition-colors m_1000:duration-200">BREND</p>
          <div id="js_brand_btn_toggle" class="transition-transform duration-300" :class="{ 'rotate-180': showBrands }">
            <arrow-icon svgClassName="text-gold size-s35"></arrow-icon>
          </div>
        </button>

        <button type="button" class="flex items-center mr-s20 group" @click="showFilters">
          <p class="text-white text-t16 mr-s5 m_800:text-t18 m_1000:group-hover:text-gold m_1000:transition-colors m_1000:duration-200 transiton duration-200">

            <template v-if="countFilters() > 0"><span>(</span>{{ countFilters() }}<span>)</span></template> Filteri

          </p>
          <filter-icon svgClassName="text-gold size-s30 m_800:size-s35"></filter-icon>
        </button>

        <button type="button" class="flex items-center group" @click="showSort = !showSort; showBrands = false"
          id="js_sort_btn">
          <p class="text-white text-t16 mr-s5 m_800:text-t18 m_1000:group-hover:text-gold m_1000:transition-colors m_1000:duration-200 transiton duration-200">Sortraj</p>
          <sort-icon svgClassName="text-gold size-s30 m_800:size-s35"></sort-icon>
        </button>
      </div>
      <div class="relative">
        <div class="hidden absolute w-3/6 top-0 left-0 z-20 m_1000:block" v-if="showBrands">
          <ul class="bg-black js_menu">

            <li v-for="(brend, index) in brends" class="text-white border-b border-darkest-gray last-of-type:border-none py-s10 px-s20">
              <a :href="brend.path" class="inline-block w-full uppercase hover:text-gold m_1000:transition-colors m_1000:duration-200"
              :class="addBrendClass(brend.path)"
              >{{ brend.title }}</a>
            </li>

          </ul>
        </div>

        <div class="w-fit absolute top-0 right-0 z-10 m_650:w-full m_1000:w-3/5" v-if="showSort">
          <ul class="bg-black w-s200 js_menu m_650:w-full">
            <li @click="sortProducts('publish_at','desc')"
              class="border-b border-darkest-gray last-of-type:border-none py-s10 px-s20 hover:text-gold m_1000:transition-colors m_1000:duration-200 cursor-pointer pagination_link"
              :class="getSortClass('publish_at', 'desc')"
            >
              Najnovije</li>
            <li @click="sortProducts('price_discounted','desc')"
              class="border-b border-darkest-gray last-of-type:border-none py-s10 px-s20 hover:text-gold m_1000:transition-colors m_1000:duration-200 cursor-pointer pagination_link"
              :class="getSortClass('price_discounted', 'desc')"
            >
              Opadajuća cena</li>
            <li @click="sortProducts('price_discounted','asc')"
              class="border-b border-darkest-gray last-of-type:border-none py-s10 px-s20 hover:text-gold m_1000:transition-colors m_1000:duration-200 cursor-pointer pagination_link"
                :class="getSortClass('price_discounted', 'asc')"
            >
              Rastuća cena</li>
            <li @click="sortProducts('discount','asc')"
              class="border-b border-darkest-gray last-of-type:border-none py-s10 px-s20 hover:text-gold m_1000:transition-colors m_1000:duration-200 cursor-pointer pagination_link"
                :class="getSortClass('discount', 'asc')"
            >
              Rastući popust</li>
            <li @click="sortProducts('discount','desc')"
              class="border-b border-darkest-gray last-of-type:border-none py-s10 px-s20 hover:text-gold m_1000:transition-colors m_1000:duration-200 cursor-pointer pagination_link"
                :class="getSortClass('discount', 'desc')"
            >
              Opadajući popust</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowIcon from "../svg/ArrowIcon.vue";
import FilterIcon from "../svg/FilterIcon.vue";
import SortIcon from "../svg/SortIcon.vue";

export default {
	name: "CategorySelect",
	components: {
		ArrowIcon,
		FilterIcon,
		SortIcon,
	},
	data() {
		return {
			showBrands: false,
			showSort: false,
			url: this.$parent.$attrs.url,
			brends: this.$parent.$attrs.categorybrends
		};
	},
	methods: {

    showFilters() {
      this.$parent._data.showFilters = true;
    },

		async sortProducts(type, value) {

			if (type === this.$parent._data.sortType && value === this.$parent._data.sortValue) {
				this.hideMenus('click');
			} else {

				this.$parent._data.loader = true;

				let selectedFiltersIds = this.$parent._data.selectedFilters.map(item => item.id);
				let selectedFiltersForUrl = selectedFiltersIds.join('&filters[]=');
				let selectedBrendsIds = this.$parent._data.selectedBrends.map(item => item.id);
				let selectedBrendsForUrl = selectedBrendsIds.join('&brends[]=');

				this.$parent._data.sortType = type;
				this.$parent._data.sortValue = value;

				let sortType = this.$parent._data.sortType;
				let sortValue = this.$parent._data.sortValue;

				if (selectedFiltersForUrl.length > 0 || selectedBrendsForUrl.length > 0) {
					var realPath = (selectedBrendsIds.length > 0 ? `brends[]=${selectedBrendsForUrl}` : "") +
						(selectedFiltersIds.length > 0 ? `&filters[]=${selectedFiltersForUrl}` : "") +
						`&sortType=${sortType}` + `&sortValue=${sortValue}`;

					await this.$router.push(`?${realPath}`);
				} else {
					await this.$router.push(`?sortType=${sortType}` + `&sortValue=${sortValue}`);
				}

				let result = await axios.get(this.url, {
					params: {
						sortType: sortType,
						sortValue: sortValue,
						filters: selectedFiltersIds,
						brends: selectedBrendsIds,
					}
				})
					.then(function (response) {

						const products = response.data.products;
						const properties = response.data.properties;

						return [products, properties];
					})
					.catch(function (error) {
						console.log(error);
					});

				this.$parent._data.products = result[0];
				this.$parent._data.loader = false;

				if (result[1] !== null) {
					this.$parent._data.properties = result[1];
				}

				this.hideMenus('click');
			}
		},
		countFilters() {
			let filtersCount = this.$parent._data.selectedFilters.length;
			let brendsCount = this.$parent._data.selectedBrends.length;
			let total = filtersCount + brendsCount;

			return total;
		},
		getSortClass(type, value){
			let sortType = this.$parent._data.sortType;
			let sortValue = this.$parent._data.sortValue;

			if (type === sortType && value === sortValue) {
				return 'text-gold';
			} else {
				return 'text-white';
			}
		},
		addBrendClass(brendPath) {
			if (this.url === brendPath) {
				return 'text-gold';
			}
		},
		toggleBrands() {
			this.showBrands = !this.showBrands;
			this.showSort = false;
		},
		toggleSort() {
			this.showSort = !this.showSort;
			this.showBrands = false;
		},
		hideMenus(event) {
			const buttons = Array.from(document.querySelectorAll('#js_brand_btn, #js_sort_btn'));
			const menus = Array.from(document.querySelectorAll('.js_menu'));

			if (!buttons.some(button => button.contains(event.target)) && !menus.some(menu => menu.contains(event.target))) {
				this.showBrands = false;
				this.showSort = false;
			}
		},
	},
	mounted() {
		document.addEventListener('click', this.hideMenus);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.hideMenus);
	},
};
</script>